import { render, staticRenderFns } from "./ExamTakerDetailsHeader.vue?vue&type=template&id=480da8a6"
import script from "./ExamTakerDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ExamTakerDetailsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports